export const ultimasNoticias = [
    
   //   {
   //      "imagen" : "assets/imgs/comisionpermanente.jpeg",

   //      "url" : "https://www.facebook.com/photo.php?fbid=1141667654661088&set=pb.100064535929070.-2207520000&type=3&locale=es_LA",
   //      "titulo" : "Contralores México",
       
   //     "fecha" : "Contralores México",
   //   }, 
   //   {
   //      "imagen" : "assets/imgs/CONTRALORIASOCIAL12.jpg",

   //      "url" : "https://www.facebook.com/share/p/1F7xuoj15B/",
   //      "titulo" : "Premio Nacional de Contralores ",
       
   //     "fecha" : "Contraloría Social",
   //   }, 


   //   {
   //      "imagen" : "assets/imgs/convocsatorias (2).jpg",
   //      "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf",

   //      "titulo" : "Premio Nacional de Contralores ",
   //       "fecha" : "Contraloría Social",
   //  }, 

 
 

     {
        "imagen" : "assets/imgs/pagina web inicio.jpg",
        "url" : "https://www.youtube.com/@SecretariadeContraloriaHidalgo",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Secretaría de Contraloría Hidalgo",
    },
     {
        "imagen" : "assets/imgs/convocatorias.jpg",
        "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/695185846755664?locale=es_LA",
        "titulo" : "Lunes CÍvico",
       "fecha" : "Lunes CÍvico",
    }, 

    
    {
        "imagen" : "assets/imgs/CEDULA.jpeg",
        "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Cédula_OIC.pdf",
        "titulo" : "Cedula de Atención ",
       "fecha" : "Órgano Interno de Control",
    },     


  
    {
        "imagen" : "noticias/seis.jpg",
         "url" : "https://buzondigitalcontraloria.hidalgo.gob.mx/",
        "titulo" : "Escanea y cuéntanos",
       "fecha" : "Denuncia cualquier acto de corrupción o atención inadecuada por parte de las personas servidoras públicas",
    },

   

 
 
 
    // {
    //     "imagen" : "noticias/comision.gif",
    //      "url" : "https://comisioncontralores.gob.mx/2023/",
    //     "titulo" : "Comisión Permanente de Contralores ",
    //    "fecha" : "Estados-Federación",
    // },     

    // {
    //     "imagen" : "noticias/9_jornada.jpg",
    //      "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1141123597339219/?mibextid=rS40aB7S9Ucbxw6v",
    //     "titulo" : "9 JORNADA DE CAPACITACIÓN ",
    //    "fecha" : "PARA LA TRANSFORMACIÓN DE HIDALGO",
    // },
    // {
    //     "imagen" : "noticias/convenio.jpg",
    //     "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1156571106119065",
    //     "titulo" : "Firma de Convenio de Donación de Sistemas por la Secretaría de la Honestidad ",
    //     "fecha" : "y la Secretaría de Contraloría de Hidalgo."
    // },
   


    // {
    //     "imagen" : "noticias/2da sesion.png",
    //     "url" : "https://www.facebook.com/share/p/14qTV3iovd/?mibextid=WC7FNe",
    //     "titulo" : " Segunda Asamblea Plenaria de la Comisión Permanente de Contralores Estado-Municipios",
    //     "fecha" : "28 de noviembre del 2024"
    // },



]